export function getTransferRequestsFields($t) {
  return [
    {
      name: 'checkbox',
      type: 'portal',
      headerPortal: 'headerCheckbox',
      is_visible: true
    },
    {
      name: 'fromStoreName',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldSenderStore')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldSenderStore')
      }
    },
    {
      name: 'storeName',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldStore')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldStore')
      }
    },
    {
      name: 'stockItemName',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldStockItem')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldStockItem')
      }
    },
    {
      name: 'requestDate',
      type: 'portal',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldDate')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldDate')
      }
    },
    {
      name: 'stockOnHandQuantity',
      type: 'quantity',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldOnHand')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldOnHand')
      }
    },

    {
      name: 'unitName',
      type: 'portal',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldUnit')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldUnit')
      }
    },
    {
      name: 'quantity',
      type: 'portal',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldRQuantity')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldRQuantity')
      }
    },

    {
      name: 'transferredQuantity',
      type: 'portal',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldQuantity')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldQuantity')
      }
    },

    {
      name: 'diffQuantity',
      type: 'portal',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldDiffQuantity')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldDiffQuantity')
      }
    },

    {
      name: 'unitPrice',
      type: 'currency',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldUnitPrice')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldUnitPrice')
      }
    },

    {
      name: 'baseUnitQuantity',
      type: 'portal',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldBaseUnitQuantity')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldBaseUnitQuantity')
      }
    },

    {
      name: 'baseUnit',
      type: 'portal',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldBaseUnit')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldBaseUnit')
      }
    },

    {
      name: 'total',
      type: 'portal',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFieldTotal')
      },
      get title() {
        return $t('RequestedTransfer.tableFieldTotal')
      }
    },

    {
      name: 'itemGroupName',
      is_visible: true,
      get short_title() {
        return $t('RequestedTransfer.tableFielditemGroupName')
      },
      get title() {
        return $t('RequestedTransfer.tableFielditemGroupName')
      }
    }
  ]
}